import ReportProductItem from "../../../../components/@reports/product/ReportProductItem";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/product/productItemSchema"

export default function ProductItemReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.product}
            reportType={reportTypes.product.productItem.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportProductItem
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       